import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

// Set to true in an HttpContext to keep a request from triggering the global
// loading overlay - for quiet background refreshes (e.g. the unread notification
// badge) where a full-screen spinner on every navigation would be noisy.
export const SKIP_LOADING = new HttpContextToken(() => false);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api') || req.context.get(SKIP_LOADING)) return next(req);

  const loading = inject(LoadingService);
  loading.start();
  return next(req).pipe(finalize(() => loading.stop()));
};
